import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { AccessManager } from '@app/core/services/managers/access.manager';
import { AppManager } from '@services/managers/app.manager';

@Directive({
  selector: '[permission-lock]',
  standalone: true
})
export class PermissionLockDirective implements OnChanges, AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly accessManager = inject(AccessManager);
  private readonly appManager = inject(AppManager);

  @Input('permission-lock') public permissions: any[] = [];

  public ngOnChanges(_: SimpleChanges): void {
    this.updatePermissionRenderer();
  }

  public ngAfterViewInit(): void {
    this.updatePermissionRenderer();
  }

  private updatePermissionRenderer(): void {
    if (this.permissions.length > 0) {
      this.permissions.forEach((permission) => {
        if (!this.accessManager.hasAccess(permission, !this.appManager.currentOrganization)) {
          this.renderer.setAttribute(this.el.nativeElement, 'hidden', 'true');
        }
      });
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'hidden');
    }
  }
}
